import { memo } from "react";
import {
  Circle as _Circle,
  Line as _Line,
  Path as _Path,
  Rect as _Rect,
  Svg as _Svg
} from "react-native-svg";
import { themed } from "../../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return <_Svg viewBox="0 0 256 256" {...otherProps} height={size} width={size}>
    <_Rect width="256" height="256" fill="none" />
    <_Line
      x1="128"
      y1="72"
      x2="128"
      y2="88"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
    <_Line
      x1="128"
      y1="168"
      x2="128"
      y2="184"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
    <_Circle
      cx="128"
      cy="128"
      r="96"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
    <_Path
      d="M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36"
      fill="none"
      stroke={`${color}`}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="8"
    />
  </_Svg>;
};
Icon.displayName = "CurrencyCircleDollarThin";
const CurrencyCircleDollarThin = memo(themed(Icon));
export {
  CurrencyCircleDollarThin
};
//# sourceMappingURL=currency-circle-dollar-thin.js.map
